<div class="wrapper">
  <label i18n for="radius-slider">Weed intensity: {{ (currentRadius - 1).toFixed(2) }}</label>
  <input
    name="radius-slider"
    type="range"
    min="1"
    max="26"
    step="0.25"
    [value]="currentRadius"
    (input)="onSliderChange($event)"
  />
</div>
